/* eslint-disable max-len */
import React from 'react';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import PropTypes from 'prop-types';
import AppointmentsContainer from 'modules/appointments/container/AppointmentsContainer';
import CalendarEntriesContainer from 'modules/calendar-entries/container/CalendarEntriesContainer';
import RequirementsContainer from './requirements/container/RequirementsContainer';
import SystemModulesContainer from './system-modules/container/SystemModulesContainer';
import CitizenTypeSettingContainer from './citizen_type/container/SettingsContainer';
import CitizenshipContainer from './citizenship/container/SettingsContainer';
import AddressContainer from './address/SettingsContainer';
import InstitutionContainer from './institution/container/InstitutionContainer';
import HospitalContainer from './hospitals/container/HospitalContainer';
import ProfessionContainer from './profession/container/ProfessionContainer';
import ViolationFeesContainer from './ovrs/violation_fees/container/ViolationFeesContainer';
import ChairmanContainer from './chairman/container/ChairmanContainer';
import BillingImportsContainer from './billing_imports/container/BillingImportsContainer';
import OTPModuleContainer from './otpModule/container/OTPModuleContainer';
import BussEstSettingsContainer from './businessEstablishments/container/BussEstSettingsContainer';
import OVRSSettings from './ovrs/OVRSSettings';
import ChatSupport from './chat-support/ChatSupport';
import HowToContainer from './how-to/HowToContainer';
import CSVUploadContainer from './csv_upload/CSVUploadContainer';
import FaqsContainer from './faqs/FaqsContainer';
import CMSContainer from './cms/container/CMSContainer';
import MiniProgramGovContainer from './mini-program-government/container/MiniProgramGovContainer';

function SettingsContainer({ match }) {
  const permissions = getJson('permissions');
  return (
    <Switch>
      {Acl(permissions, ['VIEW CITIZENSHIP GENERAL SETTINGS']) && (
        <Route
          exact
          path={`${match.path}`}
          render={() => <Redirect to={`${match.path}/citizenship`} />}
        />
      )}
      {Acl(permissions, ['VIEW SYSTEM MODULE GENERAL SETTINGS']) && (
        <Route
          path={`${match.path}/system-modules`}
          component={SystemModulesContainer}
        />
      )}
      {Acl(permissions, ['VIEW OTP GENERAL SETTINGS']) && ( // replace with OTP modules later
        <Route
          path={`${match.path}/otp-modules`}
          component={OTPModuleContainer}
        />
      )}
      {(
        <Route
          path={`${match.path}/mini-program-government`}
          component={MiniProgramGovContainer}
        />
      )}
      {(
        <Route
          path={`${match.path}/csv-upload`}
          component={CSVUploadContainer}
        />
      )}
      {Acl(permissions, ['VIEW BUSINESS ESTABLISHMENT GENERAL SETTINGS']) && (
        <Route
          path={`${match.path}/business-establishments`}
          component={BussEstSettingsContainer}
        />
      )}
      {Acl(permissions, ['VIEW REQUIREMENT GENERAL SETTINGS']) && (
        <Route
          path={`${match.path}/requirements`}
          component={RequirementsContainer}
        />
      )}
      {Acl(permissions, ['VIEW CALENDAR ENTRIES GENERAL SETTINGS']) && (
        <Route
          path={`${match.path}/calendar-entries`}
          component={CalendarEntriesContainer}
        />
      )}
      {Acl(permissions, ['VIEW CITIZEN TYPE GENERAL SETTINGS']) && (
        <Route
          path={`${match.path}/citizen-type`}
          component={CitizenTypeSettingContainer}
        />
      )}
      {Acl(permissions, ['VIEW CITIZENSHIP GENERAL SETTINGS']) && (
        <Route
          path={`${match.path}/citizenship`}
          component={CitizenshipContainer}
        />
      )}
      {Acl(permissions, ['VIEW ADDRESS GENERAL SETTINGS']) && (
        <Route path={`${match.path}/address`} component={AddressContainer} />
      )}
      {Acl(permissions, ['VIEW INSTITUTION GENERAL SETTINGS']) && (
        <Route
          path={`${match.path}/institution`}
          component={InstitutionContainer}
        />
      )}
      {Acl(permissions, ['VIEW HOSPITAL GENERAL SETTINGS']) && (
        <Route path={`${match.path}/hospitals`} component={HospitalContainer} />
      )}
      {Acl(permissions, ['VIEW PROFESSION GENERAL SETTINGS']) && (
        <Route
          path={`${match.path}/profession`}
          component={ProfessionContainer}
        />
      )}
      {Acl(permissions, ['VIEW VIOLATION FEE GENERAL SETTINGS']) && (
        <Route
          path={`${match.path}/violation-fees`}
          component={ViolationFeesContainer}
        />
      )}
      {Acl(permissions, ['VIEW BRGY CHAIRMEN GENERAL SETTINGS']) && (
        <Route
          path={`${match.path}/brgy-chairmen`}
          component={ChairmanContainer}
        />
      )}
      {Acl(permissions, ['VIEW BILLING IMPORT GENERAL SETTINGS']) && (
        <Route
          path={`${match.path}/billing-imports`}
          component={BillingImportsContainer}
        />
      )}
      {Acl(permissions, ['VIEW OVRS GENERAL SETTINGS']) && (
        <Route path={`${match.path}/ovrs`} component={OVRSSettings} />
      )}
      {Acl(permissions, ['VIEW APPOINTMENT GENERAL SETTINGS']) && (
        <Route
          path={`${match.path}/appointment-management`}
          component={AppointmentsContainer}
        />
      )}
      {Acl(permissions, ['VIEW HOW TO GENERAL SETTINGS']) && (
        <Route path={`${match.path}/how-to`} component={HowToContainer} />
      )}
      {Acl(permissions, ['VIEW FAQ GENERAL SETTINGS']) && (
        <Route path={`${match.path}/faq`} component={FaqsContainer} />
      )}
      {Acl(permissions, ['VIEW CMS GENERAL SETTINGS']) && (
        <Route path={`${match.path}/cms/:type?`} component={CMSContainer} />
      )}
      <Route path={`${match.path}/chat-support/:id?`} component={ChatSupport} />
    </Switch>
  );
}

SettingsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(SettingsContainer);
